export default "__VITE_ASSET__N3JsM0Am__"